export default {
    title: "RIPS Detail",
    subtitle: "| Invoice/Note Type:",
    payerNit: "Payer's NIT",
    payerName: "Payer's Name",
    grossValue: "Gross Value",
    invoiceNumber: "Invoice Number:",
    noteType: "Note Type:",
    paymentMode: "Payment Mode:",
    benefitPlan: "Benefit Plan",
    contract: "Contract",
    policy: "Policy",
    billingPeriodStart: "Billing Period Start",
    billingPeriodEnd: "Billing Period End",
    electronicInvoiceUniqueCode: "CUFE",
    users: "Patients",
    services: {
        consultations: "Consultations",
        procedures: "Procedures",
        emergencies: "Emergencies",
        hospitalization: "Hospitalization",
        neonates: "Newborn",
        drugs: "Medications",
        otherServices: "Other Services"
    },
    user: {
        identificationTypeCode: "Identification Document",
        identificationNumber: "Identification Number",
        userType: "User Type",
        birthDate: "Date of Birth",
        sex: "Sex",
        countryCode: "Country of Residence",
        cityCode: "Municipality",
        zoneCode: "Territorial Zone",
        hasMedicalIncapacity: "Disability",
        registrySiras: "SIRAS Code",
        sequenceId: "Consecutive",
        nativeCountryCode: "Country of Origin",
        userTotalAmount: "Account Value"
    },
    identificator: 'ID',
    totalValue: 'Total:',
    serviceDetails: {
        providerCode: "Provider",
        attentionStartAt: "Start of Attention",
        authorizationNumber: "Authorization",
        consultationCode: "Consultation",
        attentionMode: "Mode",
        serviceGroupCode: "Service Group",
        serviceCode: "Service",
        purposeCode: "Purpose",
        attentionCauseCode: "Cause of Attention",
        principalDiagnosisCode: "Principal Diagnosis",
        firstRelatedDiagnosisCode: "Related Diagnosis 1",
        secondRelatedDiagnosisCode: "Related Diagnosis 2",
        thirdRelatedDiagnosisCode: "Related Diagnosis 3",
        principalDiagnosisTypeCode: "Principal Diagnosis Type",
        identificationTypeCode: "Doctor's ID Type",
        identificationNumber: "Doctor's ID Number",
        serviceValue: "Service Value",
        revenueConceptCode: "Revenue Concept",
        moderatorPaymentValue: "Moderator Payment",
        invoiceNumber: "Moderator Payment Invoice",
        sequenceId: "Consecutive",
        mipresIdentifier: "Mipres ID",
        procedureCode: "Procedure",
        serviceEntryMode: "Entry Mode",
        relatedDiagnosisCode: "Related Diagnosis",
        complicationDiagnosisCode: "Complication Diagnosis",
        dischargeConditionAndDestinationCode: "Discharge Destination",
        demiseCauseDiagnosisCode: "Cause of Death Diagnosis",
        dischargedAt: "Discharge Date",
        gestationalAge: "Gestational Age",
        prenatalConsultationCount: "Prenatal Care Consultations Count",
        biologicalSex: "Sex",
        currentWeight: "Weight",
        drugType: "Drug Type",
        drugCode: "Health Technology",
        genericName: "Health Technology Name",
        dosageStrength: "Concentration",
        unitOfMeasure: "Unit of Measure",
        dosageForm: "Pharmaceutical Form",
        minimumUnitDispensed: "Dispensing Unit",
        drugAmount: "Quantity",
        treatmentDays: "Treatment Days",
        otherServiceType: "Other Services Type",
        otherServiceCode: "Health Technology",
        otherServiceName: "Health Technology Name",
        otherServiceAmount: "Quantity",
        otherServiceUnitCost: "Unit Cost",
        drugUnitCost: "Unit Cost",
        principalAdmissionDiagnosisCode: "Admission Diagnosis",
        principalDischargeDiagnosisCode: "Discharge Diagnosis",
        firstRelatedDischargeDiagnosisCode: "Related Diagnosis 1",
        secondRelatedDischargeDiagnosisCode: "Related Diagnosis 2",
        thirdRelatedDischargeDiagnosisCode: "Related Diagnosis 3",
        dispensationAt: "Dispensation Date",
        birthDate: "Date of Birth",
        vidaCode: "VIDA Code",
        cie11Action: "View CIE-11 diagnoses"
    },
    status: 'STATUS: ',
    cie11Dialog: {
        title: "CIE-11 Diagnoses",
        empty: "No CIE-11 diagnoses registered for this record.",
        notRegistered: "Not registered",
        columns: {
            type: "Diagnosis type",
            code: "Code",
            name: "Name"
        },
        types: {
            principal: "Principal",
            principalDischarge: "Principal Discharge",
            related: "Related",
            related1: "Related 1",
            related2: "Related 2",
            related3: "Related 3",
            relatedDischarge1: "Related Discharge 1",
            relatedDischarge2: "Related Discharge 2",
            relatedDischarge3: "Related Discharge 3",
            complication: "Complication",
            demiseCause: "Death"
        }
    }
}